<template lang="pug">
  .singleSyncItem.mt-3
    .row
      .col-md-4
        span.title {{sync.name}} <br>
        span.addedOn Added on
      .col-md-4
        span.title {{sync.source.name}} to {{sync.destination.name}} <br>
        span.addedOn Filtered only...
      .col-md-3
        .title.clearfix.d-flex.align-items.center
          .circle.float-left.mr-2(:class="statusColor") 
          .text {{syncStatus}} <br>
        span.addedOn Schedule is ON
      .col-md-1.d-flex.align-items-center
        .dropdown(v-click-outside="hideMenu")
          img(src="@/assets/imgs/dots.svg", @click="showMenu()" :class="(isMenuVisible) ? 'bordered':''").moreBtn.p-2
          .dropdown-content(v-if="isMenuVisible")
            .list.row
              .col-12.list-item(@click="edit()") Edit
              .col-12.m-0 
                hr.m-0
              .col-12.list-item(@click="showLogs()") Logs
              .col-12.m-0 
                hr.m-0
              .col-12.list-item(@click="edit(4)") Schedule
              .col-12.m-0 
                hr.m-0
              .col-12.list-item(@click="runNow()") Run now
              .col-12.m-0 
                hr.m-0
              .col-12.list-item(@click="deleteSync()") Delete
    
              
    hr
    v-dialog(:click-to-close="false")
</template>

<script>
import ClickOutside from 'vue-click-outside'
import DELETE_SYNC from '../../../graphql/DeleteSync.gql'
import RUN_NOW_SYNC from '../../../graphql/RunNowSync.gql'
export default {
  name: 'SingleSyncItem',
  props:{
    sync: Object
  },
  components: {

  },
  data() {
    return {
      isMenuVisible: false,
      syncStatus: "ready"
    }
  },
  mounted() {
  },
  methods: {
    showLogs(){
      this.$emit('showlogs', this.sync)
    },
    showMenu(){
      this.isMenuVisible = !this.isMenuVisible
    },
    hideMenu(){
      this.isMenuVisible = false
    },
    edit(tabToOpen){
       this.$router.push({name: 'edit-sync', params:{syncId: this.sync.id, openOnTab: tabToOpen}}) 
    },
    runNow(){
      this.$modal.show('dialog', {
        title: 'RUN SYNC',
        text: 'Are you sure you want to run this sync now?',
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Yes',
            handler: () => {
              this.$modal.hide('dialog');
              this.syncStatus = "running";
              // Call apollo mutation
              this.$apollo.mutate({
                mutation: RUN_NOW_SYNC,
                // Parameters
                variables: {
                  input: {
                    syncId: this.sync.id,
                  },
                }
              })
              .then((result) => {
                console.log(result.data)
                if(result.data.smartsyncRunSyncNow.success) { 
                  this.syncStatus = "ready";
                  this.$toasted.show(
                    "Sync completed successfully", 
                    {
                      type: "success",
                      duration: 3000,
                      className: "customAlert",
                      containerClass: "customAlertContainer",
                      action : {
                        text : 'Close',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                  }) 
                } else {
                  this.syncStatus = "error";
                  this.$toasted.show(
                    result.data.smartsyncRunSyncNow.error, 
                    {
                      type: "error",
                      duration: 3000,
                      className: "customAlert",
                      containerClass: "customAlertContainer",
                      action : {
                        text : 'Close',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                  }) 
                }
                this.$modal.hide('dialog')
              }, (error) => {
                console.log(error)
                this.syncStatus = "error";
                this.$toasted.show(
                  "Error while running the Sync. Retry.", 
                  {
                    type: "error",
                    duration: 3000,
                    className: "customAlert",
                    containerClass: "customAlertContainer",
                    action : {
                      text : 'Close',
                      onClick : (e, toastObject) => {
                          toastObject.goAway(0);
                      }
                  }
                }) 
                this.$modal.hide('dialog')
              })
            }
          }
        ]
      })

    },
    deleteSync(){
      this.$modal.show('dialog', {
        title: 'DELETE SYNC',
        text: 'Are you sure you want to delete this sync?',
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Yes',
            handler: () => {
              // Call apollo mutation
              this.$apollo.mutate({
                mutation: DELETE_SYNC,
                // Parameters
                variables: {
                  input: {
                    syncId: this.sync.id,
                  },
                }
              })
              .then((result) => {
                console.log(result.data.smartsyncDeleteSync.error)
                if(result.data.smartsyncDeleteSync.success) { 
                  window.location.href="/"
                } else {
                  this.$toasted.show(
                    result.data.smartsyncDeleteSync.error, 
                    {
                      type: "error",
                      duration: 3000,
                      className: "customAlert",
                      containerClass: "customAlertContainer",
                      action : {
                        text : 'Close',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                  }) 
                }
                this.$modal.hide('dialog')
              }, (error) => {
                console.log(error)
                this.$toasted.show(
                  "Error while deleting the Sync. Retry.", 
                  {
                    type: "error",
                    duration: 3000,
                    className: "customAlert",
                    containerClass: "customAlertContainer",
                    action : {
                      text : 'Close',
                      onClick : (e, toastObject) => {
                          toastObject.goAway(0);
                      }
                  }
                }) 
                this.$modal.hide('dialog')
              })
            }
          }
        ]
      })

    }
  },
  computed: {
    statusColor(){
      switch(this.syncStatus){
        case "ready": return "green-bg";
        case "running": return "yellow-bg";
        case "erro": return "red-bg";
        default: return "green-bg";
      }
    },
    // scheduleStatus(){
      
    // }
  },
  directives: {
    ClickOutside
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less');
  .title {
    font-size: 24px;
  }
  .addedOn {
    font-size: 14px;
    color: grey
  }
  .circle  {
    width: 24px;
    height: 24px;
    margin-top: auto;
    margin-bottom: auto;
    border-radius: 24px;
  }
  .green-bg {
    background-color: green;
  }
  .yellow-bg {
    background-color: orange;
  }
  .red-bg {
    background-color: red;
  }
  .moreBtn:hover{
    border: 1px solid grey;
    border-radius: 2px;
  }

  .bordered {
    border: 1px solid grey !important;
    border-radius: 2px;
  }

  .moreBtn {
    border: 1px solid #fff;
    cursor:pointer;
  }

  .dropdown-content {
    position: absolute;
    right: 150%;
    top: 0;
    bottom: 100%;
    width: 130px; 
    z-index: 100;
  }
  .list {
    background: #fff;
    border: 1px solid lightgrey;
    border-radius: 3px;
  }

  .list-item {
    padding: 5px;
    cursor: pointer;
  }
  .list-item:hover {
    background-color: #fafafa;
  }
</style>
